module.exports = __webpack_public_path__ + "img/luckyDraw-btn.88fd7c96.png";